// src/pages/AssetLibraryPage.jsx
import React from 'react';
import { Box } from '@mui/material';
import AssetLibrary from '../AssetManager/AssetLibrary';

export default function AssetLibraryPage() {
  // Full-page (not a dialog), with manager features and AUF handoff enabled
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', bgcolor: '#fff' }}>
      <AssetLibrary isModal={false} mode="manager" enableAufHandoff />
    </Box>
  );
}
